export interface AvatarLayer {
    id: string;
    name: string;
    url?: string;      // Pixel art image URL/path
    emoji?: string;    // For flags
    colorable?: boolean;
}

export const SKIN_TONES = [
    '#FFE0BD', '#E8B490', '#C68642', '#8D5524', '#4A2912'
];

export const HAIR_COLORS = [
    '#090806', '#2C222B', '#3B3024', '#4E433F', '#504444',
    '#6A4E42', '#A7856A', '#D7A270', '#E5C8A6', '#DEBC99'
];

export const CLOTHING_COLORS = [
    '#4f46e5', '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#6366f1',
    '#ec4899', '#8b5cf6', '#14b8a6', '#f97316'
];

export const AVATAR_ASSETS = {
    backgrounds: [
        { id: 'none', name: 'Nenhum', url: '' },
        { id: 'tokyo', name: 'Tokyo Neon', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/bg/tokyo.svg' },
        { id: 'eiffel', name: 'Torre Eiffel', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/bg/eiffel.svg' },
        { id: 'cristo', name: 'Cristo Redentor', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/bg/cristo.svg' },
    ],
    bodies: [
        { id: 'light', name: 'Clara', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/body/base.svg' },
        { id: 'olive', name: 'Oliva', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/body/olive.svg' },
        { id: 'medium', name: 'Média', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/body/medium.svg' },
        { id: 'dark', name: 'Escura', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/body/dark.svg' },
    ],
    face: [
        { id: 'normal', name: 'Padrão', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/face/normal.svg' },
        { id: 'happy', name: 'Feliz', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/face/happy.svg' },
    ],
    details: [
        { id: 'none', name: 'Nenhum', url: '' },
        { id: 'cleft_lip', name: 'Lábio Leporino', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/details/cleft_lip.svg' },
        { id: 'freckles', name: 'Sardas', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/details/freckles.svg' },
    ],
    clothing: [
        { id: 'basic', name: 'Camiseta', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/clothing/basic.svg' },
    ],
    hair: [
        { id: 'bald', name: 'Careca', url: '' },
        { id: 'normal', name: 'Curto Liso', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/hair/normal.svg' },
        { id: 'short', name: 'Curto', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/hair/short.svg' },
        { id: 'long_curly', name: 'Longo Cacheado', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/hair/long_curly.svg' },
    ],
    accessories: [
        { id: 'none', name: 'Nenhum', url: '' },
        { id: 'glasses', name: 'Óculos', url: 'https://pub-3d7ad7f5d04d46a5b7232c0baf46d866.r2.dev/assets/avatars/acc/glasses.svg' },
    ],
    flags: [
        { id: 'none', name: 'Nenhuma', emoji: '' },
        { id: 'br', name: 'Brasil', emoji: '🇧🇷' },
        { id: 'us', name: 'EUA', emoji: '🇺🇸' },
        { id: 'gb', name: 'UK', emoji: '🇬🇧' },
        { id: 'fr', name: 'França', emoji: '🇫🇷' },
        { id: 'jp', name: 'Japão', emoji: '🇯🇵' },
        { id: 'de', name: 'Alemanha', emoji: '🇩🇪' },
        { id: 'es', name: 'Espanha', emoji: '🇪🇸' },
        { id: 'it', name: 'Itália', emoji: '🇮🇹' },
        { id: 'pt', name: 'Portugal', emoji: '🇵🇹' },
    ]
};
